import React from 'react'
import WhatsNewBanner from 'components/UpdateWhatsNewMessage/WhatsNewBanner';
import classes from './index.module.scss';
import { Container, Col, Row } from 'react-bootstrap';

const WhatsNewBannerHome = () => {

    return (
        <section className={classes.WhatsNew}>
            <Container>
                <Row>
                    <Col>
                        <div>
                            <WhatsNewBanner styleClass="Alert_Message_Home" />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default WhatsNewBannerHome;


